import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ChevronDown } from '@outdoor-voices/ui';
import { isMobile } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import windowWidth from '@outdoor-voices/ui/dist/utils/dom/windowWidth';
import { TEXT } from '../../config/constants';
import addClass from '../../utils/dom/addClass';
import ButtonLink from '../ButtonLink';
import css from './ProductStory.module.scss';
import FeatureProductBlock from '../FeatureProductBlock';
import Image from '../Image';
import ImageScroller from './ImageScroller';
import initParallax from '../../utils/dom/initParallax';
import isIOS from '../../utils/dom/isIOS';
import MessageScroller from './MessageScroller';
import removeClass from '../../utils/dom/removeClass';
import ShopPoster from '../ShopPoster';
import ShopToolbar from '../ShopToolbar';
import windowHeight from '../../utils/dom/windowHeight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var BREAK_MOBILE = 600;

var ProductStory = /*#__PURE__*/function (_React$Component) {
  _inherits(ProductStory, _React$Component);

  var _super = _createSuper(ProductStory);

  function ProductStory(props) {
    var _this;

    _classCallCheck(this, ProductStory);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      var mobileSafari = isIOS();
      var useMobileHero = isMobile();

      if (mobileSafari) {
        removeClass(document.body, 'no-scroll');
      } else {
        addClass(document.body, 'no-scroll');
      }

      _this.setState({
        mobileSafari: mobileSafari,
        useMobileHero: useMobileHero
      });

      _this.setTitleWidth();
    });

    _defineProperty(_assertThisInitialized(_this), "setTitleWidth", function () {
      // design ask to bridge title size gap between mobile/desktop, yay
      var sizeSmall = 72;
      var sizeLarge = 108; // ends up being 120 but reduced for better margin

      var breakLarge = 960;
      var width = windowWidth();
      var inTitleScaleRange = width > BREAK_MOBILE && width <= breakLarge;
      var rangeDiff = breakLarge - BREAK_MOBILE;
      var sizeStep = (sizeLarge - sizeSmall) / 100;
      var percentProgress = (width - BREAK_MOBILE) / rangeDiff * 100;
      var scaledSize = sizeSmall + sizeStep * percentProgress;
      var fixedSize = Math.round(scaledSize * 100) / 100;
      var titleFontSize = inTitleScaleRange ? fixedSize : null;

      _this.setState({
        titleFontSize: titleFontSize
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFeaturesIntersect", function (entries) {
      entries.forEach(function (entry) {
        var intersectionRatio = entry.intersectionRatio;
        var showToolbar = intersectionRatio > 0;

        _this.updateToolbar(showToolbar);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onShopPosterIntersect", function (entries) {
      entries.forEach(function (entry) {
        var intersectionRatio = entry.intersectionRatio;
        var onShopPoster = intersectionRatio > 0.01;
        var shouldUpdate = _this.onShopPoster !== onShopPoster;
        _this.onShopPoster = onShopPoster;

        if (shouldUpdate) {
          _this.updateToolbar(!onShopPoster);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateToolbar", function (showToolbar) {
      var currentShowToolbar = _this.state.showToolbar;
      var needsToShow = showToolbar && !currentShowToolbar && !_this.onShopPoster;
      var needsToHide = !showToolbar && currentShowToolbar;
      var shouldUpdate = needsToShow || needsToHide;

      if (shouldUpdate) {
        _this.setState({
          showToolbar: showToolbar
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickExplore", function () {
      var mobileSafari = _this.state.mobileSafari;
      var top = _this.content.current.offsetTop + 108;
      var scroller = mobileSafari ? window : _this.root.current;
      scroller.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    });

    _this.content = /*#__PURE__*/React.createRef();
    _this.featureBlocks = /*#__PURE__*/React.createRef();
    _this.heroFloor = /*#__PURE__*/React.createRef();
    _this.root = /*#__PURE__*/React.createRef();
    _this.shopPoster = /*#__PURE__*/React.createRef();
    _this.onShopPoster = false;
    _this.state = {
      mobileSafari: false,
      showToolbar: false,
      titleFontSize: null,
      useMobileHero: false
    };
    return _this;
  }

  _createClass(ProductStory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var threshold = [0, 0.01, 0.02, 0.03, 0.04, 0.05, 0.5, 0.1, 0.2, 0.3, 0.4, 0.5]; // eslint-disable-line

      var featuresObserver = new IntersectionObserver(this.onFeaturesIntersect, {
        threshold: threshold
      });
      var shopPosterObserver = new IntersectionObserver(this.onShopPosterIntersect, {
        threshold: threshold
      });
      featuresObserver.observe(this.featureBlocks.current);
      shopPosterObserver.observe(this.shopPoster.current);
      initParallax(this.root.current);
      this.onResize();
      window.addEventListener('resize', this.onResize, {
        passive: true
      });
      this.initialWindowHeight = windowHeight();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cta = _this$props.cta,
          heroImage = _this$props.heroImage,
          heroImageMobile = _this$props.heroImageMobile,
          heroTitle = _this$props.heroTitle,
          heroSubtitle = _this$props.heroSubtitle,
          featureBlocks = _this$props.featureBlocks,
          messageBot = _this$props.messageBot,
          messages = _this$props.messages,
          messageTop = _this$props.messageTop,
          price = _this$props.price,
          rating = _this$props.rating,
          scrollerHeadline = _this$props.scrollerHeadline,
          scrollerImages = _this$props.scrollerImages,
          shopPoster = _this$props.shopPoster,
          title = _this$props.title,
          url = _this$props.url;
      var _this$state = this.state,
          mobileSafari = _this$state.mobileSafari,
          showToolbar = _this$state.showToolbar,
          titleFontSize = _this$state.titleFontSize,
          useMobileHero = _this$state.useMobileHero;
      var heroImageUrl = useMobileHero && heroImageMobile ? heroImageMobile : heroImage;
      var heroStyle = {
        backgroundImage: "url(".concat(heroImageUrl, ")"),
        height: mobileSafari ? this.initialWindowHeight - 108 : null
      };
      var useImageScroller = scrollerImages.length > 0;
      return /*#__PURE__*/_jsxs("div", {
        className: cc([css.root, _defineProperty({}, css.rootMobileSafari, mobileSafari), _defineProperty({}, css.rootNonMobileSafari, !mobileSafari)]),
        ref: this.root,
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("div", {
            className: cc([css.heroImage, 'parallax']),
            parallax: "0.075",
            style: heroStyle,
            children: [/*#__PURE__*/_jsxs("div", {
              className: css.title,
              style: {
                fontSize: titleFontSize
              },
              children: [/*#__PURE__*/_jsx("h1", {
                dangerouslySetInnerHTML: {
                  __html: heroTitle || title
                }
              }), heroSubtitle && /*#__PURE__*/_jsx("h2", {
                className: css.subtitle,
                children: heroSubtitle
              }), cta && /*#__PURE__*/_jsx(ButtonLink, {
                big: true,
                className: css.cta,
                href: cta.href,
                white: true,
                children: cta.text
              })]
            }), /*#__PURE__*/_jsxs("button", {
              "aria-hidden": "false",
              "aria-label": TEXT.scrollDown,
              className: css.exploreButton,
              onClick: this.onClickExplore,
              title: TEXT.scrollDown,
              type: "button",
              children: ["Explore", /*#__PURE__*/_jsx(ChevronDown, {})]
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: css.hidden,
            ref: this.heroFloor
          }), /*#__PURE__*/_jsx("div", {
            className: css.content,
            ref: this.content,
            children: /*#__PURE__*/_jsxs("div", {
              className: css.mainContent,
              children: [useImageScroller ? /*#__PURE__*/_jsx(ImageScroller, {
                headline: scrollerHeadline,
                images: scrollerImages
              }) : /*#__PURE__*/_jsx(MessageScroller, {
                messageBot: messageBot,
                messages: messages,
                messageTop: messageTop,
                mobileSafari: mobileSafari
              }), /*#__PURE__*/_jsx("section", {
                className: css.featureBlocks,
                ref: this.featureBlocks,
                children: featureBlocks.map(function (f) {
                  return /*#__PURE__*/_createElement(FeatureProductBlock, _objectSpread(_objectSpread({}, f), {}, {
                    key: f.id
                  }));
                })
              })]
            })
          }), /*#__PURE__*/_jsx("section", {
            ref: this.shopPoster,
            children: /*#__PURE__*/_jsx(ShopPoster, _objectSpread({}, shopPoster))
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: cc([css.toolbarContainer, _defineProperty({}, css.showToolbar, showToolbar)]),
          children: /*#__PURE__*/_jsx("div", {
            className: css.toolbarWrap,
            children: /*#__PURE__*/_jsx(ShopToolbar, {
              price: price,
              rating: rating,
              title: title,
              url: url
            })
          })
        })]
      });
    }
  }]);

  return ProductStory;
}(React.Component);

ProductStory.defaultProps = {
  cta: false,
  featureBlocks: [],
  heroImageMobile: false,
  heroTitle: false,
  heroSubtitle: false,
  messageBot: '',
  messages: [],
  messageTop: '',
  scrollerHeadline: '',
  scrollerImages: []
};
ProductStory.propTypes = {
  cta: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })]),
  featureBlocks: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, FeatureProductBlock.propTypes))),
  heroImage: PropTypes.string.isRequired,
  heroImageMobile: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  heroTitle: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  heroSubtitle: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  messageBot: PropTypes.string,
  messages: PropTypes.arrayOf(PropTypes.shape()),
  messageTop: PropTypes.string,
  price: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  scrollerHeadline: PropTypes.string,
  scrollerImages: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, Image.propTypes))),
  shopPoster: PropTypes.shape(_objectSpread({}, ShopPoster.propTypes)).isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
export default ProductStory;